import { Component, Input, OnInit } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

interface Tool {
  en: string;
  es: string;
}

@Component({
  selector: 'app-tools',
  template: `
    <div class="bg-gray-50 rounded-lg p-4 my-3">
      <div *ngIf="data && data.length" class="flex flex-wrap gap-2">
        <app-suggested-prompt *ngFor="let tool of data" [text]="getToolTranslation(tool)">
        </app-suggested-prompt>
      </div>

      <div *ngIf="!data || !data.length" class="text-center text-gray-500 py-4">
        No hay herramientas para mostrar
      </div>
    </div>
  `
})
export class ToolsComponent implements OnInit {
  @Input() data: Tool[] = [];

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {

  }

  getToolTranslation(tool: Tool): string {
    if(this.translateService.currentLang === 'es') {
      return tool.es;
    } else {
      return tool.en;
    }
  }
}
